import request from '@/utils/request'

// 查询列表
export const getOffer = params => {
  return request({
    url: '/offer/getOffer',
    method: 'get',
    params
  })
}

// 查询详情
export const getById = id => {
  return request({
    url: `/offer/getById/${id}`,
    method: 'get'
  })
}

// 新增
export const add = data => {
  return request({
    url: `/offer/add`,
    method: 'post',
    data
  })
}

// 修改密码
export const update = data => {
  return request({
    url: `/user/update`,
    method: 'post',
    data
  })
}

// 账号管理
export const getUserAll = params => {
  return request({
    url: '/user/getUserAll',
    method: 'get',
    params
  })
}

// 创建用户
export const register = data => {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}
